import { useMemo } from "react";

import noop from "lodash/noop";

import { GraphMetricCard } from "@similarweb/pro-logic-components";

import { percentageSignFilter } from "app/filters/ngFilters";
import { CardBenchmarkRow } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/components/CardBenchmarkRow";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import type { IMentionShareMetricCardProps } from "../types";
import { getGraphDataFromArray, getPopChangeValueProps, GRAPH_PROPS_WITH_PERCENTAGE } from "../utils";
import { MetricCardSecondary } from "../MetricCardSecondary";

export const MentionShareMetricCard = ({
    metric,
    outOfCompetitorsMentionShare,
    hasData,
    isLoading,
}: IMentionShareMetricCardProps) => {
    const translate = useTranslation();
    const graphData = useMemo(() => getGraphDataFromArray(metric.dailyData, "brandMentionShare"), [metric.dailyData]);

    return (
        <GraphMetricCard
            data-automation="brand-overview-mention-share-card"
            title={translate("llm.brand_overview.mention_share.title")}
            tooltip={translate("llm.brand_overview.mention_share.tooltip", {
                brand: metric.brandName,
            })}
            secondaryValue={
                hasData ? (
                    <MetricCardSecondary
                        caption={{
                            textKey: "llm.brand_overview.mention_share.text",
                            brand: metric.brandName,
                            mentions: metric.mentions,
                            total: metric.total,
                        }}
                        benchmark={
                            outOfCompetitorsMentionShare != null ? (
                                <CardBenchmarkRow
                                    label={translate("llm.brand_overview.mention_share.out_of_competitors")}
                                    formattedValue={percentageSignFilter()(outOfCompetitorsMentionShare, 2) as string}
                                    dataAutomation="brand-overview-mention-share-out-of-core"
                                />
                            ) : null
                        }
                    />
                ) : null
            }
            value={hasData ? percentageSignFilter()(metric.share, 2) : null}
            changeValueProps={hasData ? getPopChangeValueProps(metric.shareChange) : undefined}
            isLoading={isLoading}
            graphProps={{
                ...GRAPH_PROPS_WITH_PERCENTAGE,
                data: graphData,
            }}
            onCtaClick={noop}
        />
    );
};
